<date-input (valueOut)="setElement($event, 1)" 
[initialPlaceHolder]="'Desde'" [value]="elementSelected" [isIncomplete]="isInvalid"></date-input>

<span class="text-is-incomplete invalid-text" style="position:absolute;" *ngIf="isInvalid">La fecha es anterior.</span>